<form #cardForm="ngForm" autocomplete="off">
  <div class="col">
    <div class="card-body">
      <div class="d-flex align-items-center">
        <h1 class="fw-300 w-100 f-26 mb-4">
          {{
            apontamentos.length > 0
              ? "Apontamentos encontrados:"
              : "Nenhum apontamento encontrado"
          }}
        </h1>
      </div>
      <div class="itens-apontados">
        <ng-container *ngFor="let a of apontamentos">
          {{ a.label }}
        </ng-container>
      </div>
    </div>

    <div class="card-body">
      <h1 class="fw-300 f-26">Parecer técnico</h1>
      <div class="row p-0 m-0" *ngIf="integracao" id="transmissao">
        <div class="col-3">
          Transmitir Laudo
          <app-input-toggle
            bgOffColor="bg-danger"
            bgColor="bg-success"
            (checkedChange)="mudarTransmissaoLaudoTerceiros($event)"
            [checked]="transmitirLaudo"
          ></app-input-toggle>
        </div>
        <div *ngIf="isMultiClienteAutoAvaliar && !integrahg" class="col-6">
          <p>Informe o cnpj da unidade de transmissão</p>
          <input
            type="text"
            class="form-control"
            [textMask]="masks.cnpj"
            required="true"
            style="width: 10vw"
            [(ngModel)]="cnpjManual"
            name="cnpjManual"
            id="cnpjManual"
            minlength="18"
            autocomplete="false"
          />
        </div>
      </div>
      <div class="row p-0 m-0 btn-group-parecer">
        <div class="col-lg-3 col-12 pb-1 px-1">
          <button
            (click)="setNivelParecerTecnico(1)"
            [ngClass]="{ active: parecerTecnico == 1 }"
            class="w-100 btn btn-icon my-2 btn-success"
          >
            <i
              [ngClass]="{
                'mdi-checkbox-marked-circle': parecerTecnico == 1,
                'mdi-checkbox-blank-circle': parecerTecnico != 1
              }"
              class="mdi"
            ></i
            ><span class="w-100 text-left">{{
              parecerNomenclaturas[nomenclaturaParecer][0]
            }}</span>
          </button>
        </div>
        <div class="col-lg-3 col-12 pb-1 px-1" *ngIf="nomenclaturaParecer != 3">
          <button
            (click)="setNivelParecerTecnico(2)"
            [ngClass]="{ active: parecerTecnico == 2 }"
            class="w-100 btn btn-icon my-2 btn-warning"
          >
            <i
              [ngClass]="{
                'mdi-checkbox-marked-circle': parecerTecnico == 2,
                'mdi-checkbox-blank-circle': parecerTecnico != 2
              }"
              class="mdi"
            ></i
            ><span class="w-100 text-left">{{
              parecerNomenclaturas[nomenclaturaParecer][1]
            }}</span>
          </button>
        </div>
        <div class="col-lg-3 col-12 pb-1 px-1">
          <button
            (click)="setNivelParecerTecnico(3)"
            [ngClass]="{ active: parecerTecnico == 3 }"
            class="w-100 btn btn-icon my-2 btn-warning"
          >
            <i
              [ngClass]="{
                'mdi-checkbox-marked-circle': parecerTecnico == 3,
                'mdi-checkbox-blank-circle': parecerTecnico != 3
              }"
              class="mdi"
            ></i
            ><span class="w-100 text-left">{{
              parecerNomenclaturas[nomenclaturaParecer][2]
            }}</span>
          </button>
        </div>
        <div class="col-lg-3 col-12 pb-1 px-1" *ngIf="nomenclaturaParecer != 3">
          <button
            (click)="setNivelParecerTecnico(4)"
            [ngClass]="{ active: parecerTecnico == 4 }"
            class="w-100 btn btn-icon my-2 btn-danger"
          >
            <i
              [ngClass]="{
                'mdi-checkbox-marked-circle': parecerTecnico == 4,
                'mdi-checkbox-blank-circle': parecerTecnico != 4
              }"
              class="mdi"
            ></i
            ><span class="w-100 text-left">{{
              parecerNomenclaturas[nomenclaturaParecer][3]
            }}</span>
          </button>
        </div>
      </div>

      <div class="py-2 px-1" *ngIf="textoPadrao != ''">
        <label>Observações</label>
        <textarea
          [(ngModel)]="textoPadrao"
          name="textoPadrao"
          id=""
          rows="5"
          class="form-control"
          [disabled]="true"
        ></textarea>
      </div>
      <div class="py-2 px-1">
        <label>Parecer técnico</label>
        <textarea
          [(ngModel)]="parecerObs"
          placeholder="Observações"
          name="parecerObs"
          id=""
          rows="5"
          class="form-control"
        ></textarea>
      </div>
    </div>
  </div>

  <div class="card-footer d-flex justify-content-between">
    <button (click)="cancelar()" class="btn btn-lg px-lg-5">Cancelar</button>
    <button
      [disabled]="cardForm.invalid || cardForm.hasError('minlength')"
      (click)="confirmar()"
      class="btn btn-lg btn-success px-lg-5"
      pTooltip="Selecione a unidade de transmissão"
      tooltipPosition="top"
    >
      Confirmar
    </button>
  </div>
</form>
